export default {
    getSetting(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/settings/api?' + new URLSearchParams({
                    ...params
                }),
                type: 'GET',
            }).done((data) => {
                resolve(data);
            }).fail((xhr) => {
                reject(xhr);
            });
        });
    },
};
